import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import { backendApi } from "../../api/apiService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import noDataSvg from "../../images/noData.png";

function ShortListPopup({ Cancel, candidateId, jobId, getShortList }) {
  const [remarks, setRemarks] = useState("");

  const [shortListTab, setShortListTab] = useState(true);
  const [history, setHistory] = useState([]);
  const [openingType, setOpeningType] = useState("");
  const [openingTypes, setOpeningTypes] = useState([]);

  useEffect(() => {
    scheduleInit();
  }, []);

  const resetForm = () => {
    setRemarks("");
  };

  const handleSave = () => {
    let job_id;
    if (openingType) {
      job_id = parseInt(openingType, 10);
    } else {
      job_id = jobId;
    }
    if (!job_id) {
      toast.warn("Please select an opening", { containerId: "D" });
      return false;
    }
    var req = {
      functionName: "saveShortList",
      sec_user_id: localStorage.getItem("userId"),
      candidate_id: candidateId,
      job_opening_id: job_id,
      remarks: remarks,
      site_id: localStorage.getItem("siteId"),
    };

    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == "1") {
        toast.success("Candidate ShortListed !", { containerId: "D" });
        if (typeof getShortList === "function") {
          getShortList();
        }
        setTimeout(() => {
          setShortListTab(false);
          Cancel();
        }, 2000);
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  const scheduleInit = () => {
    var req = {
      functionName: "scheduleInit",
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success === "1") {
        //setInterviewers(response.users);
        // const transformedOptions = response.users.map((user) => ({
        //   value: user.id,
        //   label: user.fullName,
        // }));
        // setInterviewers(transformedOptions);
        setOpeningTypes(response.openingJob);
      } else {
        console.log("Error while fetching schedule interview data");
        return false;
      }
    });
  };

  return (
    <div className="modal_parent">
      <ToastContainer
        enableMultiContainer
        containerId={"D"}
        position="bottom-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div className="module_popup addPeople bfAddPeople">
        <div className="module_innerpopup module_bodypop">
          <nav className="nav nav-pills nav-justified">
            <a
              className={
                shortListTab == true
                  ? "nav-item nav-link active"
                  : "nav-item nav-link"
              }
              onClick={() => setShortListTab(true)}
            >
              ShortList Candidate
            </a>
            <a
              className={
                shortListTab == true
                  ? "nav-item nav-link"
                  : "nav-item nav-link active"
              }
              onClick={() => setShortListTab(false)}
            >
              History
            </a>
          </nav>

          {shortListTab ? (
            <div className="module_body mt-4">
              <div className="module_body_followup d-flex align-items-center justify-content-center">
                <div className="col-md-12">
                  {!jobId && (
                    <div className="input-group input-group-outline mb-2 location_search">
                      <label htmlFor="" className="form-label">
                        Opening<span className="text-danger me-1">*</span>
                      </label>
                      <div className="col-md-12 p-0 position-relative">
                        <select
                          id="role-select"
                          className="form-control popupControlSelect"
                          value={openingType}
                          onChange={(event) =>
                            setOpeningType(event.target.value)
                          }
                        >
                          <option value="">Choose Opening</option>
                          {openingTypes
                            .filter(attachData => attachData.is_active === 1)
                            .map(opening => (
                              <option key={opening.id} value={opening.id}>
                                {opening.summary}
                              </option>
                            ))}

                        </select>
                      </div>
                    </div>
                  )}
                  <div className="form-group">
                    <label for="staticEmail" className="form-label">
                      Remarks:
                    </label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={remarks}
                      onChange={(e) => setRemarks(e.target.value)}
                      rows={15}
                      style={{ height: "100px" }}
                      placeholder="Enter remarks..."
                    ></textarea>
                  </div>
                </div>
              </div>

              <div className="childIssueses px-3">
                <button className=" btn-btn btn btn-btn1 me-2" onClick={handleSave}>
                  ShortList
                </button>
                <button
                  className=" btn-btn btn btn-btn2"
                  onClick={() => {
                    Cancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          ) : (
            <div className="module_body mt-4">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th style={{ minWidth: "50px" }}>SL No:</th>
                      <th style={{ textAlign: "left", minWidth: "250px" }}>
                        Summary
                      </th>
                      <th style={{ textAlign: "left", minWidth: "150px" }}>
                        ShortListed On
                      </th>
                    </tr>
                  </thead>
                  {history.length > 0 ? (
                    history.map((data, index) => (
                      <tbody>
                        <tr>
                          <td>{index + 1}</td>
                          <td>{data.contact_date_time}</td>
                          <td>{data.created_on}</td>
                        </tr>
                      </tbody>
                    ))
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={5} className="text-center py-5">
                          <img
                            src={noDataSvg}
                            width={50}
                            height={50}
                            className="img-fluid mb-4"
                            alt="no data found"
                          ></img>
                          <p
                            className="text-danger"
                            style={{ fontSize: "16px" }}
                          >
                            No ShortLists Found
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
              <div className="childIssueses">
                <button
                  className=" btn-btn btn btn-btn2"
                  onClick={() => {
                    Cancel();
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ShortListPopup;
